export default __webpack_public_path__ + "static/media/barra.4655dbb3.png";